import {
    getPrefixedStartDateName,
    getPrefixedStartTimeName,
} from '@eb/event-date-time-pair';
import {
    minPublishDateTimeValidatorWithTimezone,
    relativePublishDateTimeValidator,
} from '@eb/react-redux-form-datetime-pair';
import gettext from '@eb/gettext';
import { isProvided } from 'js-utils/validators';
import {
    joinValidators,
    makeValidator,
} from 'eventbrite_design_system/utils/validation/validation';

import { EVENT_DATE_PICKER_PREFIX } from '../constants';

export const EVENT_START_PUBLISH_DATE = getPrefixedStartDateName(
    EVENT_DATE_PICKER_PREFIX,
);
export const EVENT_START_PUBLISH_TIME = getPrefixedStartTimeName(
    EVENT_DATE_PICKER_PREFIX,
);

const schedulePublishFieldValidator = makeValidator({
    [EVENT_START_PUBLISH_DATE]: {
        validator: isProvided,
        errorMessage: gettext('Start publish date is required.'),
    },

    [EVENT_START_PUBLISH_TIME]: {
        validator: isProvided,
        errorMessage: gettext('Start publish time is required.'),
    },
});

const relativePublishValidator = (
    {
        [EVENT_START_PUBLISH_DATE]: publishDate,
        [EVENT_START_PUBLISH_TIME]: publishTime,
    },
    { eventStartDate, eventStartTime },
) =>
    relativePublishDateTimeValidator(
        publishDate,
        publishTime,
        eventStartDate,
        eventStartTime,
        EVENT_START_PUBLISH_TIME,
    );

const minPublishTimeValidator = (
    {
        [EVENT_START_PUBLISH_DATE]: publishDate,
        [EVENT_START_PUBLISH_TIME]: publishTime,
    },
    { eventTimezone },
) =>
    minPublishDateTimeValidatorWithTimezone(
        publishDate,
        publishTime,
        EVENT_START_PUBLISH_DATE,
        eventTimezone,
    );

export const validate = joinValidators(
    schedulePublishFieldValidator,
    relativePublishValidator,
    minPublishTimeValidator,
);
